<script>
  import Header from '../components/Header.svelte';
  import rooms from '../rooms.js';

  const theme = rooms['public'].theme;
</script>

<Header {theme} />
<main class="h-full" style="background: {theme.floor.background.color}">
  <div class="container mt-32 px-6" style="max-width: 600px">
    <h1 class="text-6xl font-bold leading-none">Wuh-oh.</h1>
    <h2 class="text-4xl font-light leading-snug">Your browser doesn't like us.</h2>
    <p class="mt-6 text-xl">
      MingleSpace relies on some fancy-schmancy browser features which are only available on the
      <strong>
        <em>desktop</em>
      </strong>
      versions of Chrome and Edge.
    </p>
    <p class="mt-6 text-xl">
      Please use one of those browsers on your Mac or PC and come right back!
    </p>
  </div>
</main>
